<template>
  <div>
    <transition name="slide-fade" mode="out-in">
      <form novalidate @submit.prevent="submit" v-if="isEdit"><!-- edit -->
        <div class="row mt-3">
          <div class="col">
            <h3 v-if="showHeader">Паспортные данные</h3>
            <div class="group">
              <Input
                type="datepicker"
                caption="Дата рождения:"
                :small="true"
                bgColor="azure"
                placeholder="ДД.ММ.ГГГГ"
                :maxLength="10"
                :value="dateOfBirthStr"
                :textError="errorTextDateOfBirth"
                :isError="invalidValue(dateOfBirthError)"
                @on-input="dateOfBirthInput"
                :hideTextLength="true"
                :disabled="verified"
              />

              <template v-if="!passportIsStr"> <!-- паспортные данные разбитые поля -->
                <div class="row justify-content-between">
                  <div class="col-6">
                    <Input
                      type="text"
                      caption="Серия:"
                      :small="true"
                      :maxLength="4"
                      bgColor="azure"
                      :textError="errorTextPassportSeries"
                      :isError="invalidValue(passportSeriesError)"
                      @on-input="passportSeriesInput"
                      :value="passportSeries"
                      :disabled="verified"
                    />
                  </div>
                  <div class="col-6">
                    <Input
                      type="text"
                      caption="Номер:"
                      :small="true"
                      :maxLength="6"
                      bgColor="azure"
                      :textError="errorTextPassportNum"
                      :isError="invalidValue(passportNumError)"
                      @on-input="passportNumInput"
                      :value="passportNum"
                      :disabled="verified"
                    />
                  </div>
                </div>
                <Input
                  type="datepicker"
                  caption="Дата выдачи:"
                  :small="true"
                  bgColor="azure"
                  @on-input="dateOfIssueInput"
                  placeholder="ДД.ММ.ГГГГ"
                  :value="dateOfIssueStr"
                  :maxLength="10"
                  :textError="errorTextDateOfIssue"
                  :isError="invalidValue(dateOfIssueError)"
                  :hideTextLength="true"
                  :disabled="verified"
                />
                <Input
                  type="textarea"
                  caption="Кем выдан:"
                  :small="true"
                  bgColor="azure"
                  :textError="errorTextIssuedBy"
                  :isError="invalidValue(issuedByError)"
                  @on-input="issuedByInput"
                  :value="issuedBy"
                  :disabled="verified"
                />
                <small class="text-info" v-if="!verified">
                  <a href="#" @click.prevent="passportIsStr = true">
                    Не можете ввести данные? Попробуйте ввод одной строкой
                  </a>
                </small>
              </template>
              <Input
                v-else
                type="textarea"
                caption="Серия, номер, когда и кем выдан паспорт:"
                :small="true"
                bgColor="azure"
                @on-input="passportInfoInput"
                :textError="errorTextPassportInfo"
                :isError="invalidValue(passportInfoError)"
                :value="passportInfo"
                :disabled="verified"
              /><!-- паспортные данные строкой -->
              <br />
              <PassportDataNotChangableNotice v-if="verified" />
              <br v-else-if="false" />
              <PassportUpload />
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col" disabled v-if="showWaitDataUser">
            <button class="btn btn-primary" type="button">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Загрузка...
            </button>
          </div>
          <template v-else>
            <div class="col">
              <button type="submit" class="btn btn-primary mr-1">
                Сохранить
              </button>
              <button type="button" class="btn btn-outline-info" @click="cancel()" v-if="state !== 2">
                Отменить
              </button>
            </div>
          </template>
        </div>
      </form>
      <div v-else>
        <div class="row mt-3"><!-- read -->
          <div class="col">
            <h3 v-if="showHeader">Паспортные данные</h3>
            <button class="btn btn-secondary btn-sm float-right changeDataButton"  @click="state=0" v-if="smallEditButton && !verified">Изменить</button>
            <div class="group">
              <div class="row">
                <div class="col text-right text-muted">Дата рождения:</div>
                <div class="col">{{ dateOfBirthStr }}</div>
              </div>
              <template v-if="!passportIsStr">
                <div class="row">
                  <div class="col text-right text-muted">Серия и номер:</div>
                  <div class="col">{{ passportSeries }} {{ passportNum }}</div>
                </div>
                <div class="row">
                  <div class="col text-right text-muted">Дата выдачи:</div>
                  <div class="col">{{ dateOfIssueStr }}</div>
                </div>
                <div class="row">
                  <div class="col text-right text-muted">Кем выдан:</div>
                  <div class="col">{{ issuedBy }}</div>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="col text-right text-muted">Данные:</div>
                  <div class="col">{{ passportInfo }}</div>
                </div>
              </template>
            </div>
            <div class="row mt-3">
              <div class="col">
                <button type="button" class="btn btn-outline-info" @click="state=0" v-if="!smallEditButton">
                  Редактирование
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Input from '@/components/Input.vue'
import { parsePassportInfo } from '@/utils/amo/passportParse.js'
import { minLength, testDate, isNumber, minDate, maxDate } from '@/utils/Validate.js'
import { convertYMDtoDMY, convertDMYtoYMD } from '@/utils/convertor.js'
import PassportUpload from './passportUpload.vue'
import PassportDataNotChangableNotice from './PassportDataNotChangableNotice.vue'

export default {
  props: {
      showHeader: {
          type: Boolean,
          default: true
      },
      smallEditButton: {
          type: Boolean,
          default: false
      }
  },
  components: {
    Input,
    PassportUpload,
    PassportDataNotChangableNotice,
  },
  data() {
    return {
      dateOfBirth: this.$store.getters.getUserData.memberInfo?.birthdate || '',   // дата рождения
      dateOfBirthError: {
        wrongData: false,
        minDate: false,
        maxDate: false
      },
      passportNum: '',                                                            // номер паспорта
      passportNumError: {
        minLength: false,
        wrongSymbol: false
      },
      passportSeries: '',                                                         // серия паспорта
      passportSeriesError: {
        minLength: false,
        wrongSymbol: false
      },
      issuedBy: '',                                                               // кем выдан паспорт
      issuedByError: {
        minLength: false,
      },
      dateOfIssue: '',                                                            // дата выдачи паспорта
      dateOfIssueError: {
        wrongData: false,
        minDate: false,
        maxDate: false
      },
      passportInfo: this.$store.getters.getUserData.memberInfo?.passportInfo || '',// паспорт строкой
      passportInfoError: {
        minLength: false
      },
      passportIsStr: false,            // отображение паспортных данных строкой или раздельными полями
      showWaitDataUser: false,
      state: 1
    }
  },
  mounted() {
    this.firstLoad()
  },
  computed: {
    errorTextDateOfIssue: function() {
      let error = "";
      if (this.dateOfIssueError.wrongData) error = "Введите дату в формате: ДД.ММ.ГГГГ"
      if (this.dateOfIssueError.minDate) error = "Минимальный год 1900"
      if (this.dateOfIssueError.maxDate) error = "Дата не должна превышать текущую"
      return error;
    },
    errorTextDateOfBirth: function() {
      let error = "";
      if (this.dateOfBirthError.wrongData) error = "Введите дату в формате: ДД.ММ.ГГГГ"
      if (this.dateOfBirthError.minDate) error = "Минимальный год 1900"
      if (this.dateOfBirthError.maxDate) error = "Дата не должна превышать текущую"
      return error;
    },
    errorTextPassportNum: function() {
      let error = "";
      if (this.passportNumError.wrongSymbol) error = "Можно использовать цифры!"
      if (this.passportNumError.minLength) error = "Введите 6 символа!"
      return error;
    },
    errorTextPassportSeries: function() {
      let error = "";
      if (this.passportSeriesError.wrongSymbol) error = "Можно использовать цифры!"
      if (this.passportSeriesError.minLength) error = "Введите 4 символов!"
      return error;
    },
    errorTextIssuedBy: function() {
      let error = "";
      if (this.issuedByError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextPassportInfo: function() {
      let error = "";
      if (this.passportInfoError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    dateOfIssueStr: function() {
      return this.dateOfIssue ? convertYMDtoDMY(this.dateOfIssue) : '';
    },
    dateOfBirthStr: function() {
      return convertYMDtoDMY(this.dateOfBirth)
    },
    isEdit() {
      return this.state === 0 || this.state === 2;
    },
    verified() {
        return this.$store.getters.getUserData.memberInfo?.isPassportDataVerified;
    },
  },
  methods: {
    invalidValue(obj) {           // Проверяем значение на ошибки
      for (let key in obj) {
        if (obj[key]) return true
      }
      return false
    },
    passportNumInput(value) {
      this.passportNumError.minLength = minLength(value)
      this.passportNumError.wrongSymbol = !isNumber(Number(value))
      this.passportNum = value
    },
    passportSeriesInput(value) {
      this.passportSeriesError.minLength = minLength(value)
      this.passportSeriesError.wrongSymbol = !isNumber(Number(value))
      this.passportSeries = value
    },
    issuedByInput(value) {
      this.issuedByError.minLength = minLength(value)
      this.issuedBy = value
    },
    dateOfIssueInput(value) {
      this.dateOfIssueError.wrongData = false
      this.dateOfIssueError.maxDate = false
      this.dateOfIssueError.maxDate = false
      this.dateOfIssue = convertDMYtoYMD(value)
    },
    dateOfBirthInput(value) {
      this.dateOfBirthError.wrongData = false
      this.dateOfBirthError.maxDate = false
      this.dateOfBirthError.maxDate = false
      this.dateOfBirth = convertDMYtoYMD(value)
    },
    passportInfoInput(value) {
      this.passportInfoError.minLength = minLength(value)
      this.passportInfo = value
    },
    testPassportData() { // проверка паспортных данных для submit
      if (this.passportIsStr) return !this.invalidValue(this.passportInfoError)
      else return (!this.invalidValue(this.dateOfIssueError) &&
                  !this.invalidValue(this.passportNumError) &&
                  !this.invalidValue(this.passportSeriesError) &&
                  !this.invalidValue(this.issuedByError))
    },
    submit() {
      this.dateOfBirthError.wrongData = !testDate(this.dateOfBirth)
      this.dateOfBirthError.minDate = minDate(1900, this.dateOfBirth)
      this.dateOfBirthError.maxDate = maxDate(new Date(), this.dateOfBirth)

      if (!this.passportIsStr) {
        this.dateOfIssueError.wrongData = !testDate(this.dateOfIssue)
        this.dateOfIssueError.minDate = minDate(1900, this.dateOfIssue)
        this.dateOfIssueError.maxDate = maxDate(new Date(), this.dateOfIssue)

        this.passportNumError.minLength = this.passportNum.length < 6
        this.passportSeriesError.minLength = this.passportSeries.length < 4
        this.issuedByError.minLength = minLength(this.issuedBy)
      } else {
        this.passportInfoError.minLength = minLength(this.passportInfo)
      }

      if (!this.invalidValue(this.dateOfBirthError) && this.testPassportData()) {
        // submit
        const data = new FormData()

        data.append('birthdate', this.dateOfBirth)

        if (!this.passportIsStr) {
          data.append('passportInfo',
            `${ this.passportSeries } ${ this.passportNum }, выдан ${ this.dateOfIssueStr } ${ this.issuedBy }`)
        } else {
          data.append('passportInfo', this.passportInfo)
        }

        this.showWaitDataUser = true
        this.$store.dispatch('saveInfo', data)
        .then(() => {
          this.state = 1
          this.$emit("accept");
          this.$store.dispatch('loginWithCookie')
          .then(() => {
            this.cancel()
          })
        })
        .finally(() => {
          this.showWaitDataUser = false
        })
      }
    },
    cancel() {
      this.state = 1
      this.dateOfBirth = this.$store.getters.getUserData.memberInfo?.birthdate || ''
      this.passportNum = ''
      this.passportSeries = '',
      this.issuedBy = '',
      this.dateOfIssue = '',
      this.passportInfo = this.$store.getters.getUserData.memberInfo?.passportInfo || '',
      this.firstLoad()
    },
    firstLoad() {
      if (minLength(this.dateOfBirth)) this.state = 2
      const passInfo = parsePassportInfo(this.passportInfo)
      console.log('parsed passport', passInfo)

      if (!passInfo && this.passportInfo.length > 0) {
        this.passportIsStr = true;
      } else if (passInfo) {
        this.passportIsStr = false;
        this.passportNum = passInfo.number
        this.passportSeries = passInfo.series
        this.issuedBy = passInfo.whom
        this.dateOfIssue = passInfo.when
        if (minLength(this.passportNum)
          || minLength(this.passportSeries)
          || minLength(this.issuedBy)
          || minLength(this.dateOfIssue)) {
            this.state = 2
          }
      } else {
        this.state = 2
      }
    },
  },
}
</script>

<style scoped>
  .group {
    border-left: 5px groove rgba(0, 174, 255, 0.959);
    padding-left: 10px;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
